var _rect, _rect2, _rect3, _rect4, _rect5, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPatientSidebarCloud(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2644_33586)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 13,
    width: 64,
    height: 64,
    rx: 32,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 13,
    width: 64,
    height: 64,
    rx: 32,
    fill: "url(#paint0_radial_2644_33586)",
    fillOpacity: 0.7
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 13,
    width: 64,
    height: 64,
    rx: 32,
    fill: "url(#paint1_radial_2644_33586)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 11.4,
    y: 11.4,
    width: 67.2,
    height: 67.2,
    rx: 33.6,
    stroke: "white",
    strokeWidth: 3.2
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2644_33586",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 23,
    y: 23,
    width: 44,
    height: 44
  }, _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 23.2031,
    y: 23.2031,
    width: 43.5928,
    height: 43.5928,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2644_33586)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.1871 59.5228H35.0134C32.2586 59.5228 29.9049 58.5692 27.9523 56.662C25.9997 54.7548 25.0234 52.4238 25.0234 49.669C25.0234 47.3077 25.7348 45.2038 27.1577 43.3571C28.5805 41.5105 30.4423 40.3299 32.743 39.8152C33.4998 37.0301 35.0134 34.7748 37.2839 33.0493C39.5544 31.3237 42.1275 30.4609 45.0034 30.4609C48.5454 30.4609 51.5499 31.6946 54.0172 34.1618C56.4844 36.629 57.718 39.6336 57.718 43.1755C59.8068 43.4177 61.5399 44.3183 62.9173 45.8773C64.2948 47.4364 64.9835 49.2603 64.9835 51.3491C64.9835 53.6196 64.1888 55.5495 62.5995 57.1388C61.0102 58.7281 59.0803 59.5228 56.8098 59.5228H46.8198V46.5358L49.726 49.3511L52.2689 46.8082L45.0034 39.5428L37.738 46.8082L40.2809 49.3511L43.1871 46.5358V59.5228Z",
    fill: "#516CD3"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2644_33586",
    x: 0.200781,
    y: 0.196875,
    width: 89.5984,
    height: 89.6063,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.8
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.2 0 0 0 0 0.2 0 0 0 0 0.2 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2644_33586"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2644_33586",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_2644_33586",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(29.8889 26.3333) rotate(51.0441) scale(53.7245 53.7245)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.59
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6875,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_2644_33586",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(68.2329 69) rotate(-93.6705) scale(54.779 61.0535)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#516CD3",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#516CD3",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.861815,
    stopColor: "#516CD3",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatientSidebarCloud);
export default __webpack_public_path__ + "static/media/PatientSidebarCloud.596b957df8e7e8a3d7f55d743ec45b3c.svg";
export { ForwardRef as ReactComponent };